import type { UserVerificationProcessApi } from 'api-typings/users/users';
import type { UserVerificationProcess } from './user-verification-processes.model';

export function transformUserVerificationProcess(
  userVerificationProcessApi: UserVerificationProcessApi,
): UserVerificationProcess {
  return {
    id: userVerificationProcessApi.id,
    verificationProcessTypeId:
      userVerificationProcessApi.verification_process_type_id,
    ownerId: userVerificationProcessApi.owner_id,
    status: userVerificationProcessApi.status,
    dateCreated: userVerificationProcessApi.date_created
      ? userVerificationProcessApi.date_created * 1000
      : undefined,
  };
}
